export const getPosHash = (x: number, y: number): string => `${x};${y}`;
